const SITE_NAME = 'Centro Beautyca';

export const getEnv = (profilesActive) => {
  let env = '';
  switch (profilesActive) {
    case profiles.local:
      env = ENV_PM_APPLICATION_VALUE.LOCAL;
      break;
    case profiles.development:
      env = ENV_PM_APPLICATION_VALUE.DEV;
      break;
    case profiles.testing:
      env = ENV_PM_APPLICATION_VALUE.TEST;
      break;
    case profiles.preproduction:
      env = ENV_PM_APPLICATION_VALUE.PRE;
      break;
    case profiles.production:
      env = ENV_PM_APPLICATION_VALUE.PROD;
      break;
    default:
      env = ENV_PM_APPLICATION_VALUE.LOCAL;
  }
  return env;
};

// SONY TOOLS PROPERTY MAPPING
export const PM_FRONTEND_PROPERTIES_KEYS = {
  'enabled.modules.fidelity_points': 'enabled.modules.fidelity_points',
  'url_store.android': 'url_store.android',
  'url_store.ios': 'url_store.ios',
};

// ENABLED MODULES PREFIX
export const ENABLED_MODULES_PREFIX = 'enabled.modules.';

const profiles = {
  local: 'local',
  development: 'development',
  testing: 'testing',
  preproduction: 'preproduction',
  production: 'production',
};

const getProfileActive = () => {
  let currentProfile = 'local';
  switch (process.env.REACT_APP_ACTIVE_PROFILE) {
    case profiles.local:
      currentProfile = profiles.local;
      break;
    case profiles.development:
      currentProfile = profiles.development;
      break;
    case profiles.testing:
      currentProfile = profiles.testing;
      break;
    case profiles.preproduction:
      currentProfile = profiles.preproduction;
      break;
    case profiles.production:
      currentProfile = profiles.production;
      break;
    default:
      currentProfile = profiles.local;
  }

  return currentProfile;
};

const profilesActive = getProfileActive();

const getRouteBasename = () => {
  return process.env.PUBLIC_URL;
};

export const getApiUrl = () => {
  let apiUrl = '';
  switch (profilesActive) {
    case profiles.local:
      apiUrl = 'http://localhost:8080';
      break;
    case profiles.development:
      apiUrl = 'https://dev.ynosit.it:1999';
      break;
    case profiles.testing:
      apiUrl = 'https://test.ynosit.it:1993';
      break;
    case profiles.preproduction:
      apiUrl = 'https://pre.ynosit.it:1999';
      break;
    case profiles.production:
      apiUrl = 'https://api.centrobeautyca.storebookings.cloudapps.it';
      break;
    default:
      apiUrl = 'http://localhost:8080';
  }
  return apiUrl;
};

export const BASE_URL = getApiUrl();

// PARAMETRI ACCESSO SONYTOOLS
const ENV_PM_APPLICATION_VALUE = {
  LOCAL: 'LOCAL',
  DEV: 'DEV',
  TEST: 'TEST',
  PRE: 'PRE',
  PROD: 'PROD',
};

export const SONY_TOOLS = {
  URL: 'https://prod.ynosit.it:1993/sonytools-0.0.0.0',
  SECRET_KEY: '$2a$12$0ebzMomX3b4L.8hf97Os0uEAxI6mbkyIvuV0eHQAxEiVzHIjblskS',
  AUTH_USERNAME: 'sviluppo@ynosit.it',
  AUTH_PASSWORD: '@Ynositdev20',
  CODE_PM_APPLICATION: 'CENTRO_BEAUTYCA_BY_STORE_BOOKINGS',
  ENV_PM_APPLICATION: getEnv(profilesActive),
};

const getSiteTitle = () => {
  if (getProfileActive() !== profiles.production) {
    return `${SITE_NAME} - ${profilesActive.toLocaleUpperCase()} ENV`;
  } else {
    return `${SITE_NAME}`;
  }
};

const getVersion = (version) => {
  if (getProfileActive() === profiles.local) {
    return 'v1.0';
  } else {
    return version !== null && version !== undefined ? `v${version}` : 'v1.0';
  }
};

const getSiteFooter = (version) => {
  return `${SITE_NAME} by StoreBookings ${getVersion(
    version
  )} ${new Date().getFullYear()} | Design & Development YNOS IT s.r.l.`;
};

const isDebugEnabled = () => {
  switch (process.env.REACT_APP_IS_DEBUG_ACTIVE) {
    case 'true':
      return true;
    case 'false':
    default:
      return false;
  }
};

const UNREGISTER_CUSTOMER_NAME_ID = 0;

export default {
  unregisterCustomerNameId: UNREGISTER_CUSTOMER_NAME_ID,
  profile: profilesActive,
  apiUrl: getApiUrl(),
  secretKey: '$2a$12$dBxr2GqmZUwNgMHFBmH4MOe6l4OqoIwbI.Js6yKOC8PkW0er0qGTC',
  basename: getRouteBasename(),
  siteName: SITE_NAME,
  siteIcon: 'ion-flash',
  siteTitle: getSiteTitle(),
  getSiteFooter: getSiteFooter,
  enableAnimatedRoute: false,
  debugMode: isDebugEnabled(),
  dashboard: '/dashboard',
  google: {
    analyticsKey: 'UA-xxxxxxxxx-1',
  },
};
